import { DashboardPendingCountsDto } from '../dto/DashboardPendingCountsDto';
import { PendingCounts } from '../../../application/domain/entities/PendingCounts';
import { DASHBOARD_TEXT } from '../../ui/constants/dashboardText';

export function mapDashboardPendingCountsDtoToPendingCounts(
  dto: DashboardPendingCountsDto
): PendingCounts {
  return [
    {
      title: DASHBOARD_TEXT.actionItemsSection.section2Pending,
      count: dto.pendingSection2Count,
      path: '/pending-section-2',
    },
    {
      title: DASHBOARD_TEXT.actionItemsSection.section1Pending,
      count: dto.pendingSection1Count,
      path: '/pending-section-1',
    },
    {
      title: DASHBOARD_TEXT.actionItemsSection.pendingEVerify,
      count: dto.pendingEverifyCount,
      path: '/pending-everify-cases',
    },
    {
      title: DASHBOARD_TEXT.actionItemsSection.ssaCases,
      count: dto.ssaOrdhsCaseCount,
      path: '/pending-dhs-ssa-cases',
    },
    {
      title: DASHBOARD_TEXT.actionItemsSection.photoVerificationPending,
      count: dto.photoVerificationCount,
      path: '/pending-photo-verification',
    },
    {
      title: DASHBOARD_TEXT.actionItemsSection.pendingSSNSubmissions,
      count: dto.pendingSSNSubmissionCount,
      path: '/pending-ssn',
    },
    {
      title: DASHBOARD_TEXT.actionItemsSection.duplicateCases,
      count: dto.duplicateCasesCount ?? 0,
      path: '/e-verify/duplicate-cases',
    },
    {
      // Links to the I-9 queue filtered to the same action the badge counts (VTK-1950), so the
      // number on the tile and the length of the list it opens are the same number by construction.
      title: DASHBOARD_TEXT.actionItemsSection.reverificationsDue,
      count: dto.pendingReverificationCount ?? 0,
      path: '/reverifications-due',
    },
  ];
}
